export interface DiffTab {
  name: string;
  html: string;
}

export interface DiffCounts {
  insertCount: number;
  deleteCount: number;
}

/**
 * Count the number of <ins> and <del> tags across all diff tabs.
 * Uses regex matching on raw HTML — counts opening tags only.
 */
export function countDiffChanges(tabs: DiffTab[]): DiffCounts {
  let insertCount = 0;
  let deleteCount = 0;

  for (const tab of tabs) {
    const insMatches = tab.html.match(/<ins[^>]*>/g);
    const delMatches = tab.html.match(/<del[^>]*>/g);
    if (insMatches) insertCount += insMatches.length;
    if (delMatches) deleteCount += delMatches.length;
  }

  return { insertCount, deleteCount };
}
